function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".zdevicea{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-774.008 -7979.805)"
}, /*#__PURE__*/React.createElement("path", {
  className: "zdevice",
  d: "M792.509,7985.385H774.693a.685.685,0,0,1-.685-.685v-4.209a.685.685,0,0,1,.685-.685h17.816a.685.685,0,0,1,.685.685v4.209A.685.685,0,0,1,792.509,7985.385Zm-17.13-1.37h16.445v-2.839H775.379Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "zdevice",
  d: "M795.339,8011.846H779.9a.685.685,0,0,1-.685-.685v-12.243a.685.685,0,0,1,.685-.685h15.436a.685.685,0,0,1,.685.685v12.243A.685.685,0,0,1,795.339,8011.846Zm-14.751-1.37h14.066V7999.6H780.587Z",
  transform: "translate(-4.019 -14.219)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(778.317 7989.437) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "zdevice",
  d: "M6.865,7.569a.708.708,0,0,1-.708-.708A5.452,5.452,0,0,0,.708,1.416.708.708,0,1,1,.708,0,6.87,6.87,0,0,1,7.573,6.86.708.708,0,0,1,6.865,7.569Z",
  transform: "translate(0.023)"
}), /*#__PURE__*/React.createElement("path", {
  className: "zdevice",
  d: "M4.2,4.905h0A.709.709,0,0,1,3.49,4.2a2.759,2.759,0,0,0-.815-1.966A2.765,2.765,0,0,0,.709,1.417h0A.708.708,0,0,1,.708,0h0A4.17,4.17,0,0,1,3.677,1.229,4.167,4.167,0,0,1,4.907,4.2.708.708,0,0,1,4.2,4.905Z",
  transform: "translate(0.023 2.664)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "zdevice",
  cx: 1.076,
  cy: 1.076,
  r: 1.076,
  transform: "translate(0 5.411)"
})));

var SvgZdevice = function SvgZdevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.186,
    height: 17.822,
    viewBox: "0 0 19.186 17.822",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZdevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zdevice.c67344c8.svg";
export { ForwardRef as ReactComponent };